import { memo } from "react";

import { useOrganization } from "@asd/customer-portal-ui";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";

import { useKeycloak } from "~/providers/KeycloakProvider";
import { isUserParticipant, isUserProvider } from "~/utils/keycloakHelpers";
import { BudgetData, CompleteRegistration, Home } from "../pages";
import CareProviders from "../pages/authorized/care_providers/CareProviders";
import SelectedParticipantNavigation from "../pages/authorized/dashboard_staff/SelectedParticipantNavigation";
import MessageCenter from "../pages/authorized/message_center/MessageCenter";
import Providers from "../pages/authorized/Providers";
import Registry from "../pages/authorized/Registry";
import Reports from "../pages/authorized/reports/Reports";
import ProtectedRoute from "./ProtectedRoute";

const LayoutRoutes = () => {
  const keycloak = useKeycloak();
  const {
    configuration: { ppt },
  } = useOrganization();

  const isPPT = isUserParticipant(keycloak);
  const isProvider = isUserProvider(keycloak);

  if (!keycloak.authenticated) {
    return (
      <Box
        position="absolute"
        sx={(theme) => ({
          inset: 0,
          width: "100%",
          height: "100%",
          alignContent: "center",
          textAlign: "center",
          background: theme.palette.background.paper,
          zIndex: theme.zIndex.drawer - 1,
        })}
      >
        <CircularProgress size={150} />
        <Typography sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Routes>
      <Route element={<Home />} index />
      <Route element={<CompleteRegistration />} path="complete-registration" />

      <Route element={<ProtectedRoute />}>
        <Route element={<MessageCenter />} path="message-center" />
        {isPPT && (
          <>
            <Route element={<BudgetData />} path="budget-data" />
            <Route element={<Providers />} path="providers" />
            {!!ppt.showCareProviders && <Route element={<CareProviders />} path="careproviders" />}
          </>
        )}
        {!isPPT && !isProvider && (
          <>
            <Route element={<SelectedParticipantNavigation />} path="member" />
            <Route element={<Registry />} path="registry" />
            <Route element={<CareProviders />} path="careproviders" />
            <Route element={<Reports />} path="reports" />
          </>
        )}
      </Route>

      <Route element={<Navigate to="/" replace />} path="*" />
    </Routes>
  );
};

export default memo(LayoutRoutes);
